import type { OutlookSpaceAsset, TimeStreamAsset, TimeStreamAssets } from 'owa-timestream-types';
import updateAsset from './updateAsset';

export default function insertAsset(
    assets: TimeStreamAssets,
    outlookSpaceAsset: OutlookSpaceAsset
) {
    const asset = ({
        bounds: {
            lastKnownWidth: 0,
            lastKnownHeight: 0,
        },
        payloadId: 0,
        children: [],
        deleted: false,
    } as unknown) as TimeStreamAsset;

    updateAsset(asset, outlookSpaceAsset);

    return assets.set(outlookSpaceAsset.id, asset).get(outlookSpaceAsset.id)!;
}
